import { render } from "./Marketplace.vue?vue&type=template&id=658da23b&scoped=true&ts=true"
import script from "./Marketplace.vue?vue&type=script&lang=ts"
export * from "./Marketplace.vue?vue&type=script&lang=ts"

import "./Marketplace.vue?vue&type=style&index=0&id=658da23b&scoped=true&lang=scss"

import exportComponent from "/Users/alex/lab_dev_test/info-global/info_front_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-658da23b"]])

export default __exports__